import {Panes, TextField} from '@management-ui/core';
import React from 'react';

export default function Fields({type = {}, prefix = '', multiplePanes = true, children}) {
  return (
    <Panes
      entity={type}
      prefix={prefix}
      panes={[
        {
          title: 'Details',
          fields: [
            <TextField
              name="name"
              prefix={prefix}
              label="Name"
              rules={{required: 'Please enter a name'}}
            />,
          ]
        }
      ]}
      title={multiplePanes ? null : 'Details'}
    >{children}</Panes>
  );
}
